import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsFirstRun } from '@cian/valuation-utils-component';

import { getEstimationFiltersHash } from '../../../selectors/estimation';
import { getHouseInfo } from '../../../actions/houseInfo';
import { TThunkDispatch } from '../../../types/redux';

/**
 * После первого рендера, при изменении оценки (изменился estimationHash)
 * перезапрашивает данные для блока "Информация о доме"
 */
export function useAboutHouseDataLoading() {
  const isFirstRun = useIsFirstRun();
  const dispatch = useDispatch<TThunkDispatch>();
  const estimationHash = useSelector(getEstimationFiltersHash);

  React.useEffect(() => {
    if (!isFirstRun) {
      dispatch(getHouseInfo());
    }
    /**
     * isFirstRun - специально не добавлен, чтобы не делать лишний запрос при рендере
     * на клиенте
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, estimationHash]);
}
